/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PreviewEstimatedBasicCostDto } from '../../models/preview-estimated-basic-cost-dto';
import { PreviewEstimatedBasicCostRequest } from '../../models/preview-estimated-basic-cost-request';

export interface PreviewEstimatedBasicCost$Params {
      body: PreviewEstimatedBasicCostRequest
}

export function previewEstimatedBasicCost(http: HttpClient, rootUrl: string, params: PreviewEstimatedBasicCost$Params, context?: HttpContext): Observable<StrictHttpResponse<PreviewEstimatedBasicCostDto>> {
  const rb = new RequestBuilder(rootUrl, previewEstimatedBasicCost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PreviewEstimatedBasicCostDto>;
    })
  );
}

previewEstimatedBasicCost.PATH = '/v0/estimatedBasicCost/preview';
